<template>
  <publicPage>
    <div class="mainContent">
      <div class="head">
        <div class="zh">郑州路桥建设投资集团有限公司</div>
        <div class="en">ZhengZhou Road & Bridge Construction Investment Group Co.,Ltd</div>
      </div>
      <div class="content">
        <p>郑州路桥建设投资集团有限公司（以下简称郑州路桥集团）是郑州市人民政府于2003年成立的五大国有独资公司之一，是郑州市政府从事公路、桥梁建设投资经营活动的投资主体。</p>
        <p>集团公司拥有职工近2000人,其中本科以上学历职工占比60%，正高级职称15人,高级职称102人，一级建造师64人。拥有公路工程、建筑工程、市政公用工程施工总承包，桥梁、路基、路面专业承包共6项一级资质，公路、市政行业工程设计,工程勘察综合、监理等14项甲级资质，对外承包工程、电子与智能化工程、交通工程、水利工程等28项其它资质；拥有各类大型施工设备近500台（套）。经过多年发展，初步成长为一家业务范围集合战略投资、规划设计、基础建设、施工监理、新型材料、智慧交通、城市运营、资产管理、人文康养等多业态跨界与产业链整合的综合性集团公司。</p>
        <p>集团公司先后参与了 40 多个国内外重大项目建设工作。中标运作孟加拉国达卡-西莱特国道（N2）扩建工程 DS-2标，成为郑州第一个走向海外市场的市属国有企业；建成并成功运营全国第一个以三线精神为主题的攀枝花三线干部学院，被中组部批准为干部教育基地；建设中西部地区第一个以乡村振兴为主体的综合建设项目鹤壁全区域乡村振兴项目；与国家大数据技术应用实验室合作建设全国第一个创业中心郑州创业中心；建成并成功运营河南交通行业第一个绿色建材基地禹州钧昌建材有限公司等在行业发展和地区有影响力和示范性的项目。集团公司坚持做优做强优势传统业务，先后参与了郑少高速、少洛高速、济祁高速、京港澳高速、大广高速，江西景鹰高速、武吉高速，湖南长湘高速，内蒙古鄂尔多斯市沿黄一级公路等国内众多骨干交通路网的设计、施工和监理。</p>
        <p>集团公司立足郑州，支持郑州国家中心城市建设，服务郑州全国交通枢纽地位。“十二五”期间，采取BT模式投资承建郑州市花园路与连霍高速公路互通立交新建工程、郑少高速公路与航海路连接线、科学大道西延、郑州航空港区路网、郑州跨南水北调总干渠五座桥梁（郑州境）、大学路南延、S314郑州境改建、中原新区路网等17个项目；投资建设了交通运输部第一批13个PPP项目之一、河南省交通系统第一个PPP项目国道234焦作至荥阳黄河大桥及连接线工程；建设运营了登封市环嵩山旅游公路；全过程代建郑州市第三十二高级中学项目、郑州市国防科技学校新校区项目两个民生工程。牵头的联合体中标新G107郑州境（S312至S225段）快速化改建工程；郑少高速改扩建工程列入政府2024年度投资计划；承担了郑州市智慧农产品大数据综合服务中心建设，支持数字化、智慧化郑州建设，提升郑州国家中心城市发展品质。“7·20”郑州特大暴雨期间，集团公司组织应急抢险队参与郑少连接线贾鲁河桥、中州大道、郑新快速通道、孟庄连接线等多处抢险施工任务，承接了S314线中牟境开封交界至广惠街段修复工程等一大批水毁重建项目。</p>
        <p>集团公司扎根河南，在省内濮阳、焦作、鹤壁、信阳等地采用PPP、EPC等模式运作了濮阳市示范区市政工程、新县健康谷区域旅游基础设施建设、信阳新二十四大街沪陕高速下线至南京大道连接线改造、焦作马村区基础设施建设项目、焦作“国创·上风上水”、开封“新晋美”等大批公路、市政、人文康养等项目。</p>
        <p>集团公司广交天下合作伙伴，坚定实施“走出去”战略，业务遍及海南、贵州、四川、云南、陕西、新疆等地，走出国门，在非洲、南亚开花结果。在海南，集团公司开发了“林溪缘”华龙府、华凤府，御龙府等人文康养项目和安居项目。成立了海南多优多贸易公司和海南华胜强实业公司，拥抱海南自贸区，拥抱多元发展机遇；在贵州，合作开发、投资、建设、运营安顺市西秀区基础设施建设及美丽乡村建设项目、黔西县贵毕路加宽改造工程、岑巩县土地综合整治及配套水网建设项目等大批项目；在陕西，采用PPP模式运作了蓝田县农村生活污水治理工程项目；集团公司与中央企业、地方平台公司等建立广泛战略合作伙伴关系，在四川攀枝花、云南大理等地，投资建设三线干部管理学院、三线文化广场、花蔓邸地产、攀枝花阳光大道南延线工程、大理州集中建园新材料新能源产业片区基础设施建设（一期）、大理州集中建园贝特瑞片区工程设施建设（二期）等百亿元项目。</p>
        <p>郑州路桥集团响应国家产业结构焕新升级号召，依托科技赋能，塑造竞争优势。集团公司在内部设立首席专家岗位。同时积极介入智慧公路、智慧交通、数字经济等新兴产业。与国家千人科学家团队合作进行道路新材料的研发、生产、应用和推广，作为拟上市主体推进；与上海交通大学科研团队合作进行智慧公路、智慧交通、大数据、人工智能等科技产业化、资本化运作；与北京大学签署共建“北大-郑州路桥大数据联合实验室”协议，成立河南数字中原科技有限公司，开展大数据、数字经济等战略新兴业务，入选第一批省级数字化转型促进中心；投资建设新密绿色建材及装配式构件加工基地、登封智能交通安全设施生产基地、郑州市高新区智能交通总部基地，在战略产业上持续发力；大力推进集团公司数字化转型三年行动计划、路衍数字经济平台一期暨郑少-伏羲山乡村振兴数字平台项目建设，打造路桥云上平台，推动交旅融合、乡村振兴及区域经济发展；投资控股河南复盛供应链管理有限公司、河南藏金源仓储有限公司，持续推进新业态整合，构建优势发展资源。</p>
        <p>集团公司先后获得国家级青年文明号、交通运输文化建设卓越单位、全国“最美景观高速路”、全国5A级“司机之家”、省级文明单位、河南省交通劳动奖、河南省安全文化示范单位、河南省精神文明建设优秀单位、郑州市功勋青年突击队、郑州市先进基层党组织等180余项国家级、省市级荣誉。荣获全国工程建设AAA级诚信监理企业、全国工程建设重合同守信用监理单位。近五年来，取得各类发明专利53项，获得省市科技进步奖13项。</p>
        <p>擘画新蓝图,开启新征程。郑州路桥集团将紧紧围绕国家“十四五”规划和2035年远景目标，按照集团公司“十四五”发展目标和要求，以“传承文明、成就梦想”为企业愿景，以“为职工圆梦、为企业寻路、为政府担当、为社会造福”为企业使命，秉承“开放、创新、合作、分享”发展理念，“专业、规范、透明、高效”工作理念，“利他共生、共创共享”的经营理念，大力推进管理强企、改革强企、科技强企、人才强企、党建强企，着力构建以优势产业为核心的上下游一体化产业目录体系和有限多元化产业发展体系，不断提升企业核心竞争力，增强企业核心功能，致力于推动集团公司成为基础设施全产业链服务商、城乡融合发展建设者、数字经济和新基建开发运营商、区域资本运营主力军。在“十四五”末，打响郑州路桥集团品牌，进入国家大建筑行业第二梯队行列，为交通强国、科技强国，郑州国家中心城市建设，出彩中原做出新的更大的贡献！</p>
      </div>
      <img src="../../assets/images/pages/about/yyzz.png" alt="营业执照" class="license">
      <div class="mainContainer video" id="videoBlock">
        <video :src="src" muted autoplay loop id="video"></video>
        <div class="mask"></div>
        <div class="content">
          <div class="title">“传承文明、成就梦想”</div>

          <nuxt-link to="/qywh#video" class="play">
            <img src="../../assets/images/pages/index/play.png" alt="play" />
            观看完整宣传片
          </nuxt-link>
        </div>
      </div>
    </div>
  </publicPage>
  <!--  路桥 地图 位置标点 -->
  <div class="mapArea">
    <div class="mainContainer">
<!--      <aboutBaiduMap id="map" />-->
      <about-sky-map id="map"/>

      <div class="leftContent">
        <div class="title">联系我们</div>
        <div class="p"><img src="../../assets/images/pages/about/addres.png" alt="addres">
          地址: 河南省郑州市中原区航海西路
        </div>
        <div class="p"><img src="../../assets/images/pages/about/email.png" alt="email">
          邮编: 450000
        </div>
        <div class="p"><img src="../../assets/images/pages/about/phone.png" alt="phone">
          电话: 0371-56176587
        </div>
      </div>
      <div class="leftContent">
        <div class="title">关注我们</div>
        <div class="weChat">
            <div class='eqcode1'>
                <img src="../../assets/images/pages/index/weChat.png" alt="" style="width: 46px;height: 46px;">
                微信公众号
            </div>

            <div class='eqcode'>
                <img src="../../assets/images/pages/index/gongzhonghao.png" alt="gongzhonghao">
            </div>
        </div>

      </div>
      
    </div>
  </div>
</template>

<script setup>
import publicPage from "./components/publicPage.vue"
import {getVideo} from "../../apis";
const src = ref("")
getVideo().then(res => {
  src.value = import.meta.env.VITE_FILE_HOST + res.data.coverVideo
})


// 设置TDK
useHead({
  title: '集团简介|关于我们 - 郑州路桥建设投资集团有限公司',
})
</script>

<style scoped lang="scss">
.mainContent {
  margin-top: 20px;
  .head {
    color: var(--block-title-color);
    .zh {
      font-size: 26px;
      line-height: 1.6;
    }
    .en {
      font-size: 14px;
      letter-spacing: 0;
    }
  }
  .content {
    p {
      font-size: 18px;
      line-height: 27px;
      text-align: justify; /* 浏览器可能不支持 */
      //color: var(--secondary-text-color);
      color: #333;
      margin-top: 20px;
      text-indent: 2em;
    }
  }
  .license {
    width: 805px;
    height: 568px;
    display: block;
    margin: 10px auto 0;
  }
  .video {
    height: 528px;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    margin-top: 50px;
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .mask {
      background: rgba(89, 121, 141, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    .content {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      text-align: center;
      .title {
        font-size: 52px;
        line-height: 1.5;
        color: #FFFFFF;
        padding-top: 110px;
      }
      .numbers {
        margin-top: 115px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: var(--white);
        .block {
          display: flex;
          flex-direction: column;
          border-right: 1px solid var(--white);
          padding: 0 60px;
          &:last-child {
            border-right: none;
          }
          .number {
            font-size: 58px;
            font-weight: bold;
            > span {
              display: inline-block;
            }
          }
          .txt {
            font-size: 24px;
            margin-top: 40px;
          }
        }
      }
      .play {
        font-size: 24px;
        line-height: 1.5;
        color: var(--white);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: absolute;
        bottom: 110px;
        left: 50%;
        transform: translateX(-50%);
        > img {
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
.mapArea {
  width: 100%;
  height: 550px;
  background: #F8F8FA;
  margin-top: 100px;
  .mainContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .leftContent {
      .title {
        font-size: 24px;
        line-height: 1;
        color: var(--main-blue-color);
        margin-bottom: 67px;
      }
      .p {
        font-size: 18px;
        line-height: 2.5;
        color: #333333;
        > img {
          width: 15px;
          height: 16px;
          margin-right: 4px;
        }
      }
      .weChat{
        .eqcode1{
            height: 141px;
            display: flex;
            text-align: center;
            font-size: 18px;
            font-weight: normal;
            line-height: 46px;
            img{
                margin-right: 5px;
            }
        }
      }
      .eqcode{
        width: 141px;
        height: 141px;
        display:none;
        img{
            width: 141px;
            height: 141px;
        }
      }
      .weChat:hover{
        .eqcode1{
            display: none;
        }
        .eqcode{
            display: block;
        }
      }
      
    }
    #map {
      width: 445px;
      height: 269px;
      border-radius: 10px;
      border: 1px solid #666;
    }
  }
}
</style>